const branchRouter = [{
  path: '/branch/list',
  component: () => import('@/views/master/branch/list.vue'),
  name: 'branches',
  meta: {
    title: 'branchManagement.branches.title',
    noCache: true,
    icon: 'tree'
  }
}, {
  path: '/branch/add',
  component: () => import('@/views/master/branch/manage.vue'),
  name: 'branchManagement.branches.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'branchManagement.branches.add',
    noCache: true,
    activeMenu: '/branch/list',
    hidden: true
  }
}, {
  path: '/branch/edit/:id(.*)',
  component: () => import('@/views/master/branch/manage.vue'),
  name: 'branchManagement.branches.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'branchManagement.branches.edit',
    noCache: true,
    activeMenu: '/branch/list',
    hidden: true
  }
}];
export default branchRouter;